import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'
import StorageService from 'services/storage'

import createAuthToken from 'tasks/createAuthToken'
import getCurrentUser from 'tasks/getCurrentUser'

export default task(async function(login, password) {
  const token = await createAuthToken.perform(login, password)
  const api = inject(ApiService)
  const storage = inject(StorageService)
  api.authorize(token)
  storage.authToken = token
  await getCurrentUser.perform()
  return true

}, {
  defaultValue: null
})



// WEBPACK FOOTER //
// ./src/tasks/authorize.js